export default {
  'TITLE': 'Editar datos de la empresa',
  'CREATE_BRAND': 'Agregar datos de la empresa',
  'EDIT_BRAND': 'Editar datos de la empresa',
  'FORMS_INPUTS': {
    'NAME': 'Nombre',
    'COUNTRY': 'País',
    'REDIRECT_URL': 'URL de bienvenida',
  },
  'SAVE_BUTTON': 'Confirmar',
  'SERVER_ERROR': 'Error de conexión al servidor',
}
